import React, { FC, InputHTMLAttributes } from 'react';
import isNil from 'lodash/isNil';
import Button, { ButtonProps } from '@mui/material/Button';
import IncreaseIcon from '@mui/icons-material/Add';
import DecreaseIcon from '@mui/icons-material/Remove';
import TextField from '@mui/material/TextField';

export interface NumericInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  disableQtyEdit: boolean;
  max?: number;
  min?: number;
  onChange: (e: any) => void;
  step?: number;
  value: number;
}

const InputButton: FC<ButtonProps> = ({ children, ...props }) => (
  <Button
    sx={{ '&:disabled svg': { color: 'grey.200' } }}
    variant="newText"
    {...props}
  >
    {children}
  </Button>
);

const NumericInput: FC<NumericInputProps> = ({
  disableQtyEdit,
  max,
  min,
  onClick,
  step = 1,
  ...props
}) => {
  function increase() {
    props.onChange({ target: { value: props.value + step } });
  }

  function decrease() {
    props.onChange({ target: { value: props.value - step } });
  }

  return (
    <TextField
      InputProps={{
        endAdornment: (
          <InputButton
            disabled={props.value === max || disableQtyEdit}
            onClick={increase}
          >
            <IncreaseIcon />
          </InputButton>
        ),
        inputProps: {
          max,
          min,
          sx: {
            minWidth: 0,
            textAlign: 'center',
          },
          ...props,
        },
        onKeyDown: (e: any) =>
          [38, 40].includes(e.keyCode) && e.stopPropagation(),
        startAdornment: (
          <InputButton
            disabled={props.value === min || disableQtyEdit}
            onClick={decrease}
          >
            <DecreaseIcon />
          </InputButton>
        ),
        sx: {
          padding: 0,
        },
      }}
      disabled={disableQtyEdit}
      error={
        (!isNil(min) && props.value < min) || (!isNil(max) && props.value > max)
      }
      onClick={onClick}
      sx={{
        width: '100%',
      }}
      type="number"
    />
  );
};

export default NumericInput;
